type Props = {
  value?: string | string[]
  onChange: (val: string | string[] | undefined) => void
}

function stringifyValue(value?: string | string[]) {
  return Array.isArray(value) ? value.join(', ') : value || ''
}

export function CategoryInput({ value, onChange }: Props) {
  const input = stringifyValue(value)

  function parseValue(nextValue: string) {
    const trimmed = nextValue.trim()
    if (!trimmed) {
      onChange(undefined)
    } else if (trimmed.includes(',')) {
      onChange(trimmed.split(',').map((c) => c.trim()).filter(Boolean))
    } else {
      onChange(trimmed)
    }
  }

  return (
    <input
      value={input}
      onChange={(e) => parseValue(e.target.value)}
      placeholder="e.g. Star Wars, UCS"
    />
  )
}
